<template>
    <v-dialog v-model="dialog" width="1280px" max-width="85%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text> {{ _requestees.length }} 명 </v-btn>
        </template>

        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                자문인력배정
                <v-spacer />
                <v-icon @click="dialog = false"> mdi-close</v-icon>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col>
                        배정된 자문인력
                        <v-data-table :items="requestees" v-bind="tableProps">
                            <template v-slot:[`item.areas`]="{ item }">
                                <counsels-requestees-areas :areas="item.areas" :request="value" />
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="secondary" @click="removeRequestee(item)">mdi-minus-circle</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        미배정된 자문인력
                        <v-data-table :items="candidates" v-bind="tableProps">
                            <template v-slot:[`item.areas`]="{ item }">
                                <counsels-requestees-areas :areas="item.areas" :request="value" />
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="primary" @click="addRequestee(item)">mdi-plus-circle</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import CounselsRequesteesAreas from "./counsels-requestees-areas.vue";

const headers = [
    { text: "아이디", value: "username" },
    { text: "이름", value: "name" },
    { text: "연락처", value: "phone" },
    { text: "닉네임", value: "nickname" },
    { text: "분야", value: "areas" },
    { text: "", value: "actions", align: "right" },
];

const tableProps = {
    headers,
    "disable-sort": true,
};

export default {
    components: { CounselsRequesteesAreas },
    props: ["value"],
    computed: {
        _requestees() {
            return this.value?._requestees || [];
        },
        requestees() {
            return this.users.filter(({ _id }) => this._requestees.includes(_id));
        },
        candidates() {
            return this.users.filter((user) => !this._requestees.some((_id) => _id == user._id)).filter(({ _areas }) => _areas.includes(this.value._area));
        },
    },
    data() {
        return {
            dialog: false,
            tableProps,
            users: [],
        };
    },
    methods: {
        async addRequestee(item) {
            try {
                const { _id, _requestees = [] } = this.value;
                const { counselRequest } = await api.console.counsels.put({ _id, _requestees: [..._requestees, item._id] });
                alert("추가되었습니다.");
                this.$emit("input", counselRequest);
            } catch (error) {
                this.$handleError(error);
            }
        },
        async removeRequestee(item) {
            try {
                const { _id, _requestees = [] } = this.value;
                const { counselRequest } = await api.console.counsels.put({ _id, _requestees: _requestees.filter((_requestee) => _requestee !== item._id) });
                alert("제거되었습니다.");
                this.$emit("input", counselRequest);
            } catch (error) {
                this.$handleError(error);
            }
        },
        async getUsers() {
            try {
                const { users } = await api.console.users.gets({ params: { kind: "SUPPORTER", isApproval: true } });
                this.users = users;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        dialog() {
            if (this.dialog) this.getUsers();
        },
    },
};
</script>

<style></style>
